import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

export interface FilterConfig {
  title: string;
  selected?: boolean;
  id: number;
}

export interface FilterToolbarEvent {
  title: string;
  id: number;
}

@Component({
  standalone: false,
  selector: 'ti-tabs-toolbar',
  templateUrl: './tabs-toolbar.component.html',
  styleUrls: ['./tabs-toolbar.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsToolbarComponent {
  @Output() filterChange: EventEmitter<FilterToolbarEvent> = new EventEmitter<FilterToolbarEvent>();

  @Input() set filterConfig(filterConfig: FilterConfig[]) {
    if (!filterConfig) {
      return;
    }

    this.initializeSelectedFilter(filterConfig);
    this.config = filterConfig;
  }
  public config: FilterConfig[];
  public selectedFilter: number;

  public changeFilter(config: FilterConfig, index: number) {
    this.selectedFilter = index;
    this.filterChange.emit({ title: config.title, id: config.id });
  }

  private initializeSelectedFilter(filterConfig: FilterConfig[]) {
    const index = filterConfig.findIndex((config) => config.selected);
    this.selectedFilter = index === -1 ? 0 : index;
  }
}
